import React from 'react';

import ScrollWheelController from '../../controllers/ScrollWheelController';
import NavigationContextProvider from '../../context/NavigationContext';
import AnimationContextProvider from '../../context/AnimationContext';
import DeepLinkController from '../../controllers/DeepLinkController';
import KeystrokeController from '../../controllers/KeystrokeController';
import DetailViewContextProvider from '../../context/DetailViewContext';
import ScrollableContent from '../../components/ScrollableContent';
import DetailOverlay from '../../components/detailOverlay/DetailOverlay';
import AudioContextProvider from '../../context/AudioContext';
import FocusContextProvider from '../../components/view3D/context/FocusContext';

export default function Ai4Jokes(): JSX.Element
{
  return (<>
    <audio src='assets/audio/fraunhofer_maintheme.mp3' id={'bgm'} loop />
    <AudioContextProvider>
      <DetailViewContextProvider>
        <NavigationContextProvider>
          <AnimationContextProvider>
            <FocusContextProvider>
              <DeepLinkController/>
              <ScrollWheelController scrollSpeedMultiplier={2} />
              <ScrollableContent/>
              <DetailOverlay/>
            </FocusContextProvider>
          </AnimationContextProvider>
        </NavigationContextProvider>
        <KeystrokeController/>
      </DetailViewContextProvider>
    </AudioContextProvider>
  </>);
}
